import { jsx as a, jsxs as A } from "react/jsx-runtime";
import { useState as W, useEffect as b, useRef as I } from "react";
import { useWindowDimensions as w } from "./useWindowDimensions.js";
import { g as B, B as D } from "./themes-5f0b3c3d.mjs";
import { u as m, a as d } from "./index-6a632112.mjs";
import { Button as N } from "./button.js";
import { c as u } from "./index-98c703e1.mjs";
import { a as M } from "./tslib.es6-59e1c9d8.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./_commonjsHelpers-d4512b9c.mjs";
function E(t, o) {
  var n;
  return typeof t == "string" ? o ? ((n = o[t]) !== null && n !== void 0 || (o[t] = document.querySelectorAll(t)), t = o[t]) : t = document.querySelectorAll(t) : t instanceof Element && (t = [t]), Array.from(t || []);
}
const $ = {
  any: 0,
  all: 1
};
function y(t, o, { root: n, margin: e, amount: r = "any" } = {}) {
  if (typeof IntersectionObserver > "u")
    return () => {
    };
  const c = E(t), l = /* @__PURE__ */ new WeakMap(), T = (f) => {
    f.forEach((i) => {
      const s = l.get(i.target);
      if (i.isIntersecting !== !!s)
        if (i.isIntersecting) {
          const C = o(i);
          typeof C == "function" ? l.set(i.target, C) : p.unobserve(i.target);
        } else
          s && (s(i), l.delete(i.target));
    });
  }, p = new IntersectionObserver(T, {
    root: n,
    rootMargin: e,
    threshold: typeof r == "number" ? r : $[r]
  });
  return c.forEach((f) => p.observe(f)), () => p.disconnect();
}
function k(t, o) {
  var n = o === void 0 ? {} : o, e = n.root, r = n.margin, c = n.amount, l = n.once, T = l === void 0 ? !1 : l, p = M(W(!1), 2), f = p[0], i = p[1];
  return b(function() {
    var s;
    if (!(!t.current || T && f)) {
      var C = function() {
        return i(!0), T ? void 0 : function() {
          return i(!1);
        };
      }, g = {
        root: (s = e?.current) !== null && s !== void 0 ? s : void 0,
        margin: r,
        amount: c === "some" ? "any" : c
      };
      return y(t.current, C, g);
    }
  }, [e, t, r, T]), f;
}
const x = m.div`
  &.CTAButton-MainWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTAMainWrapper)};
  }
`, F = m.div`
  &.CTAButton-DesktopWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTADesktopWrapper)};
  }
`, S = m.div`
  &.CTAButton-MobileWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTAMobileWrapper)};
  }
`, v = m.div`
  &.CTAButton-Title {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTATitle)};
  }
`, _ = m.div`
  &.CTAButton-ButtonWrapper {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTAButtonWrapper)};
  }
`, P = m.button`
  @keyframes slide-in-out {
    0%,
    12%,
    100% {
      right: 100%;
    }
    6% {
      right: 0%;
    }
  }

  @keyframes textColorChange {
    0%,
    12%,
    100% {
      color: var(--animateTextFill, '${B.primitive.color.skyview[1100]}');
    }
    6% {
      color: var(
        --animateTextDefault,
        '${B.primitive.color.twilight["000"]}'
      );
    }
  }

  &.CTAButton-Btn-Contact {
    ${({
  theme: {
    components: { ctaButton: t }
  }
}) => d(t.FordProDefaultCTAButton.CTAButtonContact)};
  }
`, h = ({
  contact: t,
  isMobile: o = !1,
  onClick: n
}) => {
  const e = I(null), r = k(e);
  return /* @__PURE__ */ a(
    P,
    {
      ref: e,
      $isMobile: o,
      onClick: n,
      className: u(
        "CTAButton-Btn-Contact",
        { mobile: o },
        { animate: r }
      ),
      tabIndex: o ? 0 : -1,
      children: /* @__PURE__ */ a("span", { className: "contact", children: t })
    }
  );
}, X = ({
  titleText: t = "Software Sales Support:",
  className: o,
  onClick: n,
  contact: e,
  buttonProps: r
}) => {
  const { width: c } = w();
  return /* @__PURE__ */ a(
    x,
    {
      className: u(["CTAButton-MainWrapper", o]),
      children: c > D.tabletMin ? /* @__PURE__ */ A(F, { className: u(["CTAButton-DesktopWrapper"]), children: [
        /* @__PURE__ */ a(v, { className: u(["CTAButton-Title"]), children: t }),
        /* @__PURE__ */ a(h, { contact: e })
      ] }) : /* @__PURE__ */ A(S, { className: u(["CTAButton-MobileWrapper"]), children: [
        /* @__PURE__ */ a(v, { className: u(["CTAButton-Title"]), children: t }),
        /* @__PURE__ */ A(_, { className: u(["CTAButton-ButtonWrapper"]), children: [
          /* @__PURE__ */ a(h, { contact: e, onClick: n, isMobile: !0 }),
          /* @__PURE__ */ a(
            N,
            {
              buttonType: "secondary",
              onClick: n,
              leftIcon: r?.leadingIcon,
              rightIcon: r?.trailingIcon,
              children: r?.buttonText || "Call Now"
            }
          )
        ] })
      ] })
    }
  );
};
export {
  X as CTAButton
};
